var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { observable, makeObservable, action } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
import { SelectMemberDialogState } from "../UIComponents/SelectMemberDialog";
export class ManageViewState {
    constructor() {
        this.views = [];
        this.loading = false;
        this.basedialogstatte = new BaseDialogState();
        this.letrid = "";
        this.objectid = "";
        this.deleteingids = new Map();
        this.mstate = new SelectMemberDialogState();
        makeObservable(this);
        this.mstate.readmode = true;
        this.mstate.basestate.setHeaderLabel("Viewers");
        this.basedialogstatte.setHideCancelButton(true);
        this.basedialogstatte.setHeaderLabel("Manage Views");
        this.basedialogstatte.setOkLabel("Done");
        this.basedialogstatte.setModalSize("full");
        APPEvent.addSubscriberForTabsReq((res) => {
            if (res.letrid === this.letrid && res.objectid === this.objectid && res.getall) {
                this.setViews(res.tabs);
                this.setLoading(false);
            }
        });
        APPEvent.addSubscriberForDeleteTab((tab) => {
            const atab = this.deleteingids.get(tab.id);
            if (atab) {
                this.removeDeleteId(tab.id);
                if (tab.ok) {
                    this.removeTab(atab);
                }
            }
        });
        this.basedialogstatte.onOk = () => {
            this.basedialogstatte.setOpen(false);
        };
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setViews(view) {
        this.views.splice(0, this.views.length);
        this.views.push(...view);
    }
    removeTab(tab) {
        const index = this.views.indexOf(tab);
        if (index > -1) {
            this.views.splice(index, 1);
        }
    }
    removeDeleteId(id) {
        this.deleteingids.delete(id);
    }
    deleteId(id, tab) {
        this.deleteingids.set(id, tab);
        const req = {
            id: id,
            letrid: this.letrid
        };
        Apphandler.sendMessage("deletetab", req);
    }
    reset() {
        this.setLoading(false);
        this.setViews([]);
        this.deleteingids.clear();
    }
    getTabs() {
        if (this.loading) {
            return;
        }
        const req = {
            letrid: this.letrid,
            objectid: this.objectid,
            getall: true
        };
        this.setLoading(true);
        Apphandler.sendMessage("gettabs", req);
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], ManageViewState.prototype, "views", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ManageViewState.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ManageViewState.prototype, "deleteingids", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ManageViewState.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], ManageViewState.prototype, "setViews", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ManageViewState.prototype, "removeTab", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ManageViewState.prototype, "removeDeleteId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], ManageViewState.prototype, "deleteId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ManageViewState.prototype, "reset", null);
